export default import.meta.ROLLDOWN_FILE_URL_TKaGGxu5Mqw5Ve$2nKTXNg